import { useState, useEffect, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { randomNumber, unicodeToString } from "../../../Js/Common";
import { Typography } from "@mui/material";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import IconButton from "@mui/material/IconButton";
import AudioButton from "../../../Components/Media/AudioButton";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import PauseIcon from "@mui/icons-material/Pause";
import "./style.css";
import Webcam from "react-webcam";
import { commonSliceActions } from "../../../Store/Slices/CommonSlice";
import VideoRecPopup from "../../../Components/Modal/VideoRecPopup";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "presentation",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 1,
};
const videoConstraints = {
  width: 320,
  height: 240,
  facingMode: "user",
};

const VIDEOREC = (props) => {
  // Hooks
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const webcamRef = useRef(null);
  const mediaRecorderRef = useRef(null);

  // State
  const [userAnswer, setUserAnswer] = useState([]);
  const [capturing, setCapturing] = useState(false);
  const [recordedChunks, setRecordedChunks] = useState([]);
  const [localUrl, setLocalUrl] = useState(null);
  const [visible, setVisible] = useState(false);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(-1);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt } = useSelector(
    (state) => state.currentAsset
  );
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  useEffect(() => {
    if (props.content) {
      console.log("OLLLLLLL", props.content);
      if (props.content?.epage?.preference?.isPopup) {
        setVisible(true);
        setOptions(props.content?.epage?.options?.content);
      }
    }
  }, [props.content]);

  const handleStartCaptureClick = useCallback(() => {
    setCapturing(true);
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: "video/webm",
    });
    mediaRecorderRef.current.addEventListener(
      "dataavailable",
      handleDataAvailable
    );
    mediaRecorderRef.current.start();
  }, [webcamRef, setCapturing, mediaRecorderRef]);

  const handleDataAvailable = useCallback(
    ({ data }) => {
      if (data.size > 0) {
        setRecordedChunks((prev) => prev.concat(data));
      }
    },
    [setRecordedChunks]
  );

  useEffect(() => {
    if (!capturing && recordedChunks.length) {
      const blob = new Blob(recordedChunks, {
        type: "video/webm",
      });
      const url = URL.createObjectURL(blob);
      setLocalUrl(url);
    }
  }, [capturing, recordedChunks]);

  const handleStopCaptureClick = useCallback(() => {
    mediaRecorderRef.current.stop();
    setCapturing(false);
  }, [mediaRecorderRef, webcamRef, setCapturing]);

  const resetVideo = () => {
    setLocalUrl(null);
    setCapturing(false);
    setRecordedChunks([]);
  };

  const uploadVideoClick = () => {
    document.getElementById("videofile").click();
  };

  const handleFileChange = (e) => {
    dispatch(commonSliceActions.setLoader(true));
    let files = e.target.files;
    if (!files.length) return;
    let reader1 = new FileReader();
    let file = files[0];
    reader1.readAsDataURL(file);
    reader1.onload = (e) => {
      loadHandler(e);
    };
  };

  const loadHandler = async (e) => {
    let result = e.target.result;
    const base64Response = await fetch(result);
    const wwblob = await base64Response.blob();

    let url = URL.createObjectURL(wwblob);
    if (localUrl) {
      setLocalUrl(null);
      setTimeout(() => {
        setLocalUrl(url);
        dispatch(commonSliceActions.setLoader(false));
      }, 1000);
    } else {
      setLocalUrl(url);
      dispatch(commonSliceActions.setLoader(false));
    }
  };

  return (
    <Grid item xs={12}>
      <Box
        sx={{
          py: 2,
          mx: 6,
          mt: 1,
          height: "58vh",
        }}
      >
        <Grid
          container
          sx={{
            flexDirection: "row",
            flexFlow: "wrap",
            justifyContent: "center",
            px: 2,
            gap: 3,
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              textAlign: "center",
            }}
          >
            {localUrl && (
              <video height={240} width={320} controls>
                <source src={localUrl}></source>
              </video>
            )}
            {(!recordedChunks || recordedChunks.length == 0) &&
              props.content.epage.preference.isRecord && (
                <Webcam
                  audio={false}
                  height={240}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  width={320}
                  videoConstraints={videoConstraints}
                  onUserMediaError={(err) => {
                    //setErrFlag(true);
                    //props.error(err.message);
                  }}
                  onUserMedia={(ff) => {
                    //setErrFlag(false);
                  }}
                />
              )}
          </Grid>
          <Grid item xs={12}>
            <Box>
              <Grid
                container
                justifyContent={"center"}
                sx={{
                  flexDirection: "row",
                  mt: 1,
                  borderRadius: 10,
                  boxShadow: 0,
                  cursor: "pointer",
                  py: 2,
                }}
              >
                <Grid item sx={{ ml: 1, cursor: "pointer" }}>
                  {props.content.epage.preference.isUpload && (
                    <Button
                      variant="contained"
                      sx={{
                        textTransform: "inherit",
                        borderRadius: 10,
                        boxShadow: 3,
                        fontWeight: "600",
                        fontSize: "1rem",
                      }}
                      onClick={uploadVideoClick}
                    >
                      Upload Video
                    </Button>
                  )}
                  {props.content.epage.preference.isRecord && (
                    <Button
                      variant="contained"
                      sx={{
                        textTransform: "inherit",
                        borderRadius: 10,
                        boxShadow: 3,
                        fontWeight: "600",
                        fontSize: "1rem",
                        marginLeft: "2rem",
                        backgroundColor: capturing ? "#ba1e13" : "#DB8829",
                       
                      }}
                      onClick={() => {
                        capturing
                          ? handleStopCaptureClick()
                          : !capturing && localUrl
                          ? resetVideo()
                          : handleStartCaptureClick();
                      }}
                    >
                      {capturing
                        ? "Stop Video Capturing"
                        : !capturing && localUrl
                        ? "Capture Video Again"
                        : "Start Video Capturing"}
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <input
          type="file"
          id="videofile"
          name="videofile"
          accept="video/*"
          style={{ display: "none" }}
          onInput={handleFileChange}
        ></input>
      </Box>
      <VideoRecPopup
        visible={visible}
        primaryText={"Select one option."}
        image={"error"}
        selectedOption={selectedOption}
        persistent={true}
        setSelectedOptionIndex={(index) => {
          setSelectedOption(index);
        }}
        secondaryText={""}
        confirmText={"OK"}
        confirm={() => {
          setVisible(false);
        }}
        options={options}
      ></VideoRecPopup>
    </Grid>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default VIDEOREC;
